import type { Session } from "@qub/base-client";
import { useEffect, useState } from "react";
import { qubbase } from "@/lib/qubbase";

/**
 * The signed-in session, kept in sync with qubbase.auth. `undefined` while the stored session is being
 * restored on page load, `null` when signed out.
 */
export function useSession() {
  const [session, setSession] = useState<Session | null | undefined>(undefined);

  useEffect(() => {
    const { data } = qubbase.auth.onAuthStateChange((_event, next) =>
      setSession(next),
    );
    return () => {
      data.subscription.unsubscribe();
    };
  }, []);

  return session;
}
